import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

import {IpAddressingMethod} from '@/model/network/IpAddressingMethod';
import {IpAddress} from '@/model/network/IpAddress';
import {IpRoute} from '@/model/network/IpRoute';

export abstract class IpSettings {

  @jsonArrayMember(IpAddress, {name: 'addresses'})
  public Addresses!: IpAddress[];

  @jsonMember({name: 'dadTimeout'})
  public DadTimeout!: number;

  @jsonMember({name: 'dhcpClientId'})
  public DhcpClientId!: string;

  @jsonMember({name: 'dhcpFqdn'})
  public DhcpFqdn!: string;

  @jsonMember({name: 'dhcpHostname'})
  public DhcpHostname!: string;

  @jsonMember({name: 'dhcpHostnameFlags'})
  public DhcpHostnameFlags!: number;

  @jsonMember({name: 'dhcpIaid'})
  public DhcpIaid!: string;

  @jsonMember({name: 'dhcpSendHostname'})
  public DhcpSendHostname!: boolean;

  @jsonMember({name: 'dhcpTimeout'})
  public DhcpTimeout!: number;

  @jsonArrayMember(String, {name: 'dnss'})
  public Dnss!: (string | null)[];

  @jsonArrayMember(String, {name: 'dnsOptions'})
  public DnsOptions!: string[];

  @jsonMember({name: 'dnsPriority'})
  public DnsPriority!: number;

  // @jsonArrayMember(String, {name: 'dnsSearch'})
  public DnsSearch!: string[];

  @jsonMember({name: 'gateway'})
  public Gateway!: string;

  @jsonMember({name: 'ignoreAutoDns'})
  public IgnoreAutoDns!: boolean;

  @jsonMember({name: 'ignoreAutoRoutes'})
  public IgnoreAutoRoutes!: boolean;

  @jsonMember({name: 'mayFail'})
  public MayFail!: boolean;

  @jsonMember({name: 'method', constructor: String})
  public Method!: IpAddressingMethod;

  @jsonMember({name: 'neverDefault'})
  public NeverDefault!: boolean;

  @jsonArrayMember(IpRoute, {name: 'routes'})
  public Routes: IpRoute[] = [];

  @jsonMember({name: 'routeMetric'})
  public RouteMetric?: number;

  @jsonMember({name: 'routeTable'})
  public RouteTable!: number;

  protected constructor(ipSettings?: Partial<IpSettings>) {
    if (ipSettings) {
      Object.assign(this, ipSettings);

      if (ipSettings.Addresses) {
        this.Addresses = ipSettings.Addresses.map((a) => a.copy());
      }
      if (ipSettings.Dnss) {
        this.Dnss = JSON.parse(JSON.stringify(ipSettings.Dnss));
      }
      if (ipSettings.DnsOptions) {
        this.DnsOptions = JSON.parse(JSON.stringify(ipSettings.DnsOptions));
      }
      if (ipSettings.DnsSearch) {
        this.DnsSearch = JSON.parse(JSON.stringify(ipSettings.DnsSearch));
      }
      if (ipSettings.Routes) {
        this.Routes = ipSettings.Routes.map((r) => new IpRoute(r));
      }
    }
  }

  get HasAddress(): boolean {
    return this.Addresses && this.Addresses.length > 0;
  }

  get HasAddresses(): boolean {
    return this.Addresses && this.Addresses.length > 1;
  }

  get HasDns(): boolean {
    return this.Dnss && this.Dnss.length > 0;
  }

  get HasDnss(): boolean {
    return this.Dnss && this.Dnss.length > 1;
  }

  protected onDeserialized() {
    if (this.RouteMetric === -1) {
      this.RouteMetric = undefined;
    }
  }
}

@jsonObject({
  onDeserialized: 'onDeserialized',
})
export class Ip4Settings extends IpSettings {
  constructor(ipSettings?: Partial<Ip4Settings>) {
    super(ipSettings);
  }

  protected onDeserialized() {
    super.onDeserialized();
  }
}

@jsonObject({
  onDeserialized: 'onDeserialized',
})
export class Ip6Settings extends IpSettings {
  constructor(ipSettings?: Partial<Ip6Settings>) {
    super(ipSettings);
  }

  protected onDeserialized() {
    super.onDeserialized();
  }
}
